import { Injectable } from '@angular/core'
import { APIService } from 'api/module'
import { TranslateService } from '@ngx-translate/core'
import { O } from 'ts-toolbelt'
import { CustomFieldsService } from 'media.customFields'
import {
  MediaRoot, Asset, MediaFileBundle, MediaFile,
  WorkflowTransitionRequest, WorkflowTransitionResponse,
} from 'elements-sdk'

@Injectable({ providedIn: 'root' })
export class WorkflowService {
  constructor (
    private customFields: CustomFieldsService,
    private api: APIService,
    private translate: TranslateService,
  ) { }

  getState (root: MediaRoot|null, id: number): null|any[] {
    if (!root?.workflow) {
      return null
    }

    // TODO: MediaRoot.workflow is a DictField
    // The schema allways falls back to string for the values
    return (root.workflow as any).states.find(x => x.id === id)
  }

  resetAssetState (asset: O.Writable<O.Required<Asset, 'id'>, 'workflowState'>): void {
    asset.workflowState = 0
    this.api.mediaLibrary.updateAsset({
      id: asset.id,
      assetUpdate: asset,
    })
  }

  transition (options: WorkflowTransitionRequest): Promise<WorkflowTransitionResponse> {
    return this.api.mediaLibrary.transitionWorkflow({
      workflowTransitionRequest: options,
    })
  }

  ensureTransitionAllowed (
    transition: { from: number, required_fields: null|string[] },
    bundle: MediaFileBundle,
    location?: MediaFile,
  ): void {
    const asset = bundle.asset
    const combinedFields = this.customFields.combine(
      location ? location.customFields : null,
      asset?.customFields,
      bundle.mainfile.customFields,
    )

    if (asset?.workflowState !== transition.from) {
      throw new Error(this.translate.instant('Asset is not in the correct workflow state'))
    }
    if (transition.required_fields) {
      for (const fieldName of transition.required_fields) {
        if (!combinedFields[fieldName]) {
          throw new Error(this.translate.instant('Missing required field {{ fieldName }}', { fieldName }))
        }
      }
    }
  }
}
